// Shared ink and row geometry for the School nav surface (the permanent left
// sidebar and the hamburger drawer that renders the same contents at the same
// width). The background is the same dark the navbar takes in night mode and the
// footer always wears, so the three chrome surfaces read as one. Content on top
// is white; dividers are a faint white wash rather than the light shell's black
// one.
export const NAV_SURFACE_BG = "#263238";
export const NAV_SURFACE_DIVIDER = "1px solid rgba(255, 255, 255, 0.12)";
export const NAV_SURFACE_HOVER = "rgba(255, 255, 255, 0.12)";

// The wash that marks the row you are on - the active nav item, the school you
// are currently in.
export const NAV_ROW_ACTIVE = "rgba(255, 255, 255, 0.18)";
export const NAV_ROW_ACTIVE_HOVER = "rgba(255, 255, 255, 0.24)";

// Row metrics every clickable line on the surface shares - the nav items and the
// school switcher trigger alike. The wrapper around them carries a single unit of
// side padding, so rows stay wide without moving the caret off its column.
export const NAV_ROW_SX = { borderRadius: 1, py: 1, pl: 0.5 };

// The leading slot of a row: the caret column on a nav item, the same column the
// switcher's checkmark occupies so the two lists share one left edge.
export const NAV_CARET_SLOT_SX = {
  width: 30,
  mr: 0.5,
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};
export const NAV_CARET_ICON_SIZE = 22;
